import { produce } from 'immer';
import { isRequestAction, requestProducer } from './requestReducerHelper';

const initialState = {
  trackingPagesByShop: {},
};

const trackingPagesReducer = (state = initialState, action = {}) => produce(state, draft => {
  if (isRequestAction(action, 'TRACKING_PAGES')) {
    return requestProducer(draft, action, 'TRACKING_PAGES', {
      successProducer: (draft, action) => {
        const { shopId, data } = action.data;
        draft.trackingPagesByShop[shopId] = data;
      }
    });
  }

  return draft;
});


export default trackingPagesReducer;